import logger from '@cvg/react-logger'

const options = {
  appId: import.meta.env.PUBLIC_APP_ID
}

export default logger(options)
